<template>
  <div class="no-padding content-area no-sidebar">
   <div class="container">
      <main class="col-md_12 site-main main-content">
         <article class="post-5835 page type-page status-publish hentry">
            <div class="vc_row wpb_row vc_row-fluid">
               <div class="wpb_column vc_column_container vc_col-sm-12">
                  <div class="vc_column-inner">
                     <div class="wpb_wrapper">
                        <div class="title-subtile-holder">
                           <h4 class="section-title" style="padding-top: 20px;font-size: 22px;">Lịch đấu giá</h4>
                        </div>
                        <div class="vc_empty_space" style="height: 20px"><span class="vc_empty_space_inner"></span></div>
                        <div class="woocommerce_categories">
                           <table id="DataTable-icondrops-active" class="table dataTable no-footer" cellspacing="0" width="100%">
                              <thead>
                                 <tr>
                                    <th style="text-align: center;">Ảnh</th>
                                    <th style="text-align: center;">Lịch đấu giá</th>
                                    <th style="text-align: center;">Thời gian bắt đầu</th>
                                    <th style="text-align: center;">Giá khởi điểm</th>
                                    <th style="text-align: center;">Người có tài sản</th>
                                 </tr>
                              </thead>
                              <thead></thead>
                              <tbody>
                                 <tr v-for="i in list_auction_do">
                                    <td class="featured-image" style="text-align: center;">
                                        <img width="180" height="75" :src="i.DinhKem.length>0? i.DinhKem[0].LinkDownload : ''">
                                    </td>
                                    <td class="product-title">
                                        <a v-on:click="seeDetail(i.PhienDauGia.Id)">{{i.PhienDauGia.TenKeHoach}}</a>
                                    </td>
                                    <td>{{i.PhienDauGia.BatDau | formatDate}}</td>
                                    <td>
                                        <span class="woocommerce-Price-amount amount">{{i.GiaKhoiDiem.toLocaleString()}}</span>
                                    </td>
                                    <td class="add-cart">
                                        {{i.ChuTaiSan}}
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </article>
      </main>
   </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
import moment from 'moment'
import CONFIG from '@/common/config'
import Auction from "@/common/api/auction"
export default {
  name: 'AuctionCalendar',
  mixins: [mixin],
  data () {
    return {
        list_auction_do: [],
    }
  },
  filters: {
      formatDate: function (value) {
         if (!value) return ''
         return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
      }
   },
   created() {
     this.getListAuctionDo()
  },
  methods: {
    seeDetail(id){
      this.$router.push("/product/detail/"+id)
   },
   getListAuctionDo(){
      Auction.getList(CONFIG.ID_AUCTION_DO)
      .then(({ data }) => {
         this.list_auction_do = data.Data;
      })
   }
  },
}
</script>

<style scoped>
table, th, td {
   border: 1px solid #e6e6e6;
} 
td,
th {
    padding: 10px 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/AuctionCalendar.vue